import { render } from "./UnacceptedApplicationResult.vue?vue&type=template&id=5210bb2f&ts=true"
import script from "./UnacceptedApplicationResult.vue?vue&type=script&lang=ts"
export * from "./UnacceptedApplicationResult.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__